import React from 'react';

export type NodeDataPoint = any;

interface SankeyNodesComponentProps {
  nodes: NodeDataPoint[];
  steps: number[];

  render?(step: number, x: number): React.ReactNode;
}

export const SankeyStepsComponent = ({
  nodes,
  steps,
  render,
}: SankeyNodesComponentProps): JSX.Element => {
  return (
    <div style={{ position: 'absolute', top: 0, left: 10 }}>
      {steps.map((step) => {
        const node = nodes.find((n) => n.level === step);
        if (!node) return null;
        const x = node.x0;
        let children;
        if (typeof render === 'function') {
          children = render(step, x);
        } else {
          children = `Step ${step}`;
        }
        return (
          <div style={{ position: 'absolute', left: x }} key={`step-${step}`}>
            {children}
          </div>
        );
      })}
    </div>
  );
};
